import { render } from "./Accidents.vue?vue&type=template&id=4c286c5e"
import script from "./Accidents.vue?vue&type=script&lang=js"
export * from "./Accidents.vue?vue&type=script&lang=js"
script.render = render

export default script